import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ForgetMeNotIcon } from "../ForgetMeNotIcon";

const FADE = { initial: { opacity: 0, y: 24 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-80px" }, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } };

const PRODUCT_IMG = "/brand/product/adult-lavender-topdown.png";

export function ProductReveal() {
    const { t } = useTranslation();
    const features = [
        { t: t("product.feature_1_title"), b: t("product.feature_1_body") },
        { t: t("product.feature_2_title"), b: t("product.feature_2_body") },
        { t: t("product.feature_3_title"), b: t("product.feature_3_body") },
    ];

    return (
        <section className="relative py-32 px-6 rem-petal-bg overflow-hidden" data-testid="product-section">
            <div className="max-w-7xl mx-auto">
                <motion.div {...FADE} className="text-center mb-16">
                    <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#6B7DB8] font-semibold mb-6">
                        {t("product.eyebrow")}
                    </p>
                    <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2D2B2A] leading-tight max-w-3xl mx-auto">
                        {t("product.headline_part1")} <em className="italic text-[#4A5A95]">{t("product.headline_part2")}</em><br/>
                        {t("product.headline_part3")}
                    </h2>
                </motion.div>

                <motion.div {...FADE} transition={{ ...FADE.transition, delay: 0.1 }} className="relative max-w-4xl mx-auto">
                    <div className="rounded-[2.5rem] overflow-hidden shadow-rem-card">
                        <img
                            src={PRODUCT_IMG}
                            alt="remembr 15-inch lavender tablet and matching headphones — branded with the forget-me-not flower"
                            className="w-full h-auto object-cover"
                            data-testid="product-hero-image"
                            loading="lazy"
                        />
                    </div>
                </motion.div>

                <motion.div {...FADE} transition={{ ...FADE.transition, delay: 0.15 }} className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
                    {features.map((f, i) => (
                        <div key={f.t} className="bg-white/70 backdrop-blur rounded-2xl p-7 border border-[#E5E1D8]/60" data-testid={`product-feature-${i}`}>
                            <div className="flex items-center gap-2 mb-3">
                                <ForgetMeNotIcon size={18} />
                                <p className="font-sans text-[11px] uppercase tracking-[0.22em] text-[#6B7DB8] font-semibold">{t("product.bundle_includes")}</p>
                            </div>
                            <h3 className="font-serif text-2xl text-[#2D2B2A] mb-2">{f.t}</h3>
                            <p className="text-[#5C5A59] leading-relaxed font-light text-sm">{f.b}</p>
                        </div>
                    ))}
                </motion.div>

                <motion.p {...FADE} transition={{ ...FADE.transition, delay: 0.25 }} className="mt-12 text-center text-sm text-[#8A8786] max-w-2xl mx-auto" data-testid="product-shipping-note">
                    {t("product.shipping_note")}
                </motion.p>
            </div>
        </section>
    );
}
